namespace GeniuzPOS.ReportMasterData {
    export interface Report_1319Row {
        Id?: string;
        PromoCampaign?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        Qty?: number;
        BasePrice?: number;
        PromoDics?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1319Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1319';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            Qty = "Qty",
            BasePrice = "BasePrice",
            PromoDics = "PromoDics",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
